var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef } from '@angular/core';
import { ButtonWidget as _ButtonWidget } from '../angular2-schema-form-shim';
var ButtonWidget = (function (_super) {
    __extends(ButtonWidget, _super);
    function ButtonWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ButtonWidget.prototype, "classes", {
        get: function () {
            var classes = ['btn'];
            classes.push(this.button.class);
            return classes.join(' ');
        },
        enumerable: true,
        configurable: true
    });
    ButtonWidget.prototype.ngAfterViewInit = function () {
        if (this.button.tooltip) {
            jQuery(this.element.nativeElement).tooltip({
                title: this.button.tooltip,
                placement: 'top',
            });
        }
    };
    ButtonWidget.prototype.ngOnDestroy = function () {
        if (this.button.tooltip) {
            jQuery(this.element.nativeElement).tooltip('destroy');
        }
    };
    return ButtonWidget;
}(_ButtonWidget));
export { ButtonWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/button.widget.ts.pre-build-optimizer.js